import React, { useState, useEffect, useRef } from 'react';
import { Empty, DatePicker, message, Select, Cascader, Pagination, Form, Popover, Button, Table, Dropdown, Spin } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import moment from 'moment';//日期格式化导包
import NewMessage from '../../component/newMessage/newMessage';
import PartnerSeeAllJobSort from './partnerSeeAllJobSort';
import { partnerCheckLogin } from '../newMain/partnerMain';
import MessageConfirm from '../../component/messageConfirm/messageConfirm';
import './partnerSeeAllJobPosting.css';

import searchImg from '../../public/img/newMain/Search.png';
import sortImg from '../../public/img/newMain/Sort.png';
import resetImg from '../../public/img/newMain/Reset.png';
import duplicateImg from '../../public/img/newMain/Duplicate.png';
import inspectImg from '../../public/img/newMain/Inspect.png'
import studentImg from '../../public/img/newMain/Student.png';
import select1 from '../../public/img/std/select1.png';
import select3 from '../../public/img/std/select3.png';
import select5 from '../../public/img/std/select5.png';
import fillImg from '../../public/img/std/fill.png'
import deleteIcon from '../../public/img/newMain/deleteIcon.png';
import deleteIconGray from '../../public/img/newMain/deleteIconGray.png';
import duplicateGrayImg from '../../public/img/newMain/duplicateGrayImg.png';
import ellipsis from '../../public/img/std/ellipsis.png'

const PartnerSeeAllJobPosting = (props) => {
    const history = useHistory();
    const messageRef = useRef();
    const messageConfirmRef = useRef();
    const [form] = Form.useForm();
    const { showStatus } = useParams();
    const [jobList, setJobList] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});
    const [areaOptions, setAreaOptions] = useState([]);
    const [pageSize, setPageSize] = useState(9);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const jobPostModelRef = useRef({});
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});
    const [showMode, setShowMode] = useState('Box');
    const [isLoad, setIsLoad] = useState(false);
    const [withdrawnModel, setWithdrawnModel] = useState({});

    const statusMap = {
        DRAFT: "Draft",
        SUBMITTED: "THEi Reviewing",
        ACTIVE: "Active",
        REJECTED: "THEi Rejected",
        EXPIRED: "Expired",
        WITHDRAWN: "Withdrawn",
    }

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchAllJobList(pageSize, 1);
        searchAllArea();
    }, []);

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchAllJobList = (pageSizeNew, currentPageNew, jobModel) => {
        let model = {}
        form.validateFields().then(() => {
            if (jobSortPostModel) {
                model = { ...jobSortPostModel }
            }
            if (jobModel) {
                model = { ...jobModel }
            }
            let formModel = JSON.parse(JSON.stringify(jobPostModelRef.current));
            model.appDeadStartDate = formModel.appDeadStartDate
            model.appDeadEndDate = formModel.appDeadEndDate
            model.jobTitle = formModel.jobTitle
            model.pageSize = pageSizeNew;
            model.startRow = (currentPageNew - 1) * pageSizeNew;
            model.page = currentPageNew;
            model.partnerId = Config.partnerInfo?.partnerId;
            if (!model.workLocIdList) {
                model.workLocIdList = jobPostModel?.workLocIdList;
            }
            if (showStatus != 'all') {
                model.jobPostStatusList = [showStatus]
            }
            Base.callBackApi("partnerHome/searchAllJobList", model).then((data) => {
                if ("SUCCESS" === data?.msg) {
                    setTablesCount(data?.object?.total ?? 0);
                    setJobList(data?.object?.list ?? []);
                    setCurrent(currentPageNew);
                    setPageSize(pageSizeNew);
                } else {
                    console.log("error", data?.msg);
                    message.error(data?.msg);
                }
            }).catch(err => { });
        })
    }

    const reset = () => {
        setJobPostModel({});
        jobPostModelRef.current = {};
        setJobSortPostModel({});
        form.resetFields();
        setIsReset(true);
        searchAllJobList(9, 1, {});
    }

    const modelChange = (key, value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ [key]: value } };
            return { ...model, ...{ [key]: value } };
        });
        if (Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate')) ||
            Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return
        }
        searchAllJobList(pageSize, 1);
    }

    const jump = (path) => {
        localStorage.removeItem("partnerDuplicateJobId");
        history.push(path);
    }

    const jumpDetail = (record) => {
        localStorage.removeItem("partnerDuplicateJobId");
        if (record.jobPostStatus == "DRAFT" || record.jobPostStatus == "REJECTED" || record.jobPostStatus == "SUBMITTED") {
            history.push('/partner/partnerJobPostingDetail/' + record.jobId + "/edit");
        } else {
            history.push('/partner/partnerJobPostingDetail/' + record.jobId + "/view");
        }
    }

    const jumpDuplicate = (jobId) => {
        localStorage.setItem('partnerDuplicateJobId', jobId);
        history.push("/partner/partnerCreateJobPosting");
    }

    const onChangeAddressA = (value) => {
        let m;
        setJobPostModel(model => {
            m = { ...model, workLocIdList: value };
            jobPostModelRef.current = { ...model, workLocIdList: value };
            return { ...model, workLocIdList: value };
        });
        searchAllJobList(pageSize, 1, m);
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            searchAllJobList(pageSize, 1, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };

    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadEndDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadStartDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const changeShowMode = (value) => {
        setPageSize(9);
        setShowMode(value)
    }

    const onChange = (currentNew, pageSizeNew) => {
        document.getElementById("container").scrollTop = 0;
        searchAllJobList(pageSizeNew, currentNew);
    }

    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchAllJobList(pageSizeNew, 1);
    }

    const saveSubmit = (record) => {
        if (isLoad) {
            return;
        }
        let model = record;
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("jobPost/submit", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully created a job posting. Please wait for the module convener to approve the job posting before it can be published.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteJob = (record) => {
        if (isLoad) {
            return;
        }
        let model = record;
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("jobPost/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully deleted a job posting.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const saveWithdrawn = () => {
        if (isLoad) {
            return;
        }
        let model = {};
        model.menuFuncId = Config.funcInfo.funcId;
        model.jobId = withdrawnModel.jobId;
        model.lastUpdatedDate = withdrawnModel.lastUpdatedDate;
        setIsLoad(true);
        Base.callBackApi("jobPost/withdrawn", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                messageConfirmRef.current.setIsShow(false);
                opendialog("You've successfully withdrawn a job posting.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const messageConfirmShow = (msg, record) => {
        setWithdrawnModel(record)
        messageConfirmRef.current.setContent(msg)
        messageConfirmRef.current.setIsShow(true)
    }

    const withdrawnDone = (flag) => {
        if (flag) {
            saveWithdrawn()
        } else {
            messageConfirmRef.current.setIsShow(false);
        }
    }

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        searchAllJobList(pageSize, current);
    }

    const tableColumns = {
        jobId: "job_id",
        jobTitle: "job_title",
        progTitle: "prog_title",
        positionTypeVal: "position_type",
        expCommenceDate: "exp_commence_date",
        expEndDate: "exp_end_date",
        lastApplyDate: "last_apply_date",
        jobPostStatus: "job_post_status",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!jobSortPostModel.orderBy) {
            if (orderBy !== jobSortPostModel.orderBy) {
                jobSortPostModel.orderBy = orderBy;
                searchAllJobList(pageSize, 1);
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth8',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth18',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth17',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgrammeBox'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Job Mode',
            dataIndex: 'positionTypeVal',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'positionTypeVal') },
        },
        {
            title: 'Commence Date',
            dataIndex: 'expCommenceDate',
            className: 'tableWidth10',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'expCommenceDate') },
        },
        {
            title: 'End Date',
            dataIndex: 'expEndDate',
            className: 'tableWidth10',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'expEndDate') },
        },
        {
            title: 'Application Deadline',
            dataIndex: 'lastApplyDate',
            className: 'tableWidth12',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'lastApplyDate') },
        },
        {
            title: 'Status',
            dataIndex: 'jobPostStatus',
            className: 'tableWidth14',
            render: text => (
                <div className='tableStatusBox'>
                    <div className={'tableStatus ' + text}>
                        {statusMap[text]}
                    </div>
                </div>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobPostStatus') },
        },
        {
            title: 'Action',
            dataIndex: 'jobId',
            fixed: 'right',
            width: 80,
            render: (text, record) =>
                <Dropdown trigger={['hover']}
                    placement="bottomLeft"
                    destroyPopupOnHide={true}
                    // getPopupContainer={() => document.getElementById("jobPostDetail"+item.jobId)}
                    dropdownRender={() =>
                        <div>
                            {record.jobPostStatus === "DRAFT" &&
                                <Button icon={<img src={deleteIconGray} />} onClick={() => deleteJob(record)}>
                                    Delete
                                </Button>
                            }
                            <Button icon={<img src={duplicateGrayImg} />} className='cardButton' onClick={() => jumpDuplicate(record.jobId)}>
                                Duplicate
                            </Button>
                            {(record.jobPostStatus === "SUBMITTED" || record.jobPostStatus === "DRAFT") ?
                                <Button icon={<img src={fillImg} />} onClick={() => jumpDetail(record)}>
                                    Edit
                                </Button>
                                :
                                <Button icon={<img src={select1} />} onClick={() => jumpDetail(record)}>
                                    Show Detail
                                </Button>
                            }
                            {record.jobPostStatus === "DRAFT" &&
                                <Button icon={<img src={select3} />} disabled={isLoad} onClick={() => saveSubmit(record)}>
                                    Submit
                                </Button>
                            }
                            {record.jobPostStatus == "ACTIVE" || record.jobPostStatus == "SUBMITTED" ?
                                <Button icon={<img src={select5} />} disabled={isLoad} onClick={() => messageConfirmShow('Warning: Withdrawn job posting will terminate all current processing job application and turn status into “Withdrawn”. The offer accepted by student already will not be affected.', record)}>
                                    Withdrawn
                                </Button>
                                : ""}
                        </div>
                    }
                >
                    <div className='ellipsisBox'><img src={ellipsis} /></div>
                </Dropdown>
        },
    ];
    /*eslint-disable*/

    return (
        <div id="container" className='websiteTemplate partnerSeeAllJobPosting'>
            <Spin size="large" spinning={isLoad} >
                <div className='paddingBox'>
                    <div className='homeTitle'>All Job Postings</div>
                    <NewMessage ref={messageRef} done={done} />
                    <MessageConfirm ref={messageConfirmRef} done={withdrawnDone} />
                    <Form form={form}>
                        <div className="websiteSysSearchRow">
                            <div className='searchFlex'>
                                <div className='label'>Application Deadline: </div>
                                <div className='searchFlex'>
                                    <div style={{ position: "relative" }} id="appDeadStartDate">
                                        <Form.Item
                                            name="appDeadStartDate"
                                            rules={[
                                                { validator: (rule, value) => checkStartDate(value) },
                                            ]}
                                        >
                                            <DatePicker placeholder=""
                                                className="searchDatePickerWidth"
                                                value={jobPostModel?.appDeadStartDate ? moment(new Date(jobPostModel.appDeadStartDate), Config.dateFormatEn) : null}
                                                onChange={(value) => modelChange("appDeadStartDate", value)}
                                                format={Config.dateFormatEn}
                                                getPopupContainer={() => document.getElementById('appDeadStartDate')}
                                            />
                                        </Form.Item>
                                    </div>
                                    <span>-</span>
                                    <div style={{ position: "relative" }} id="appDeadEndDate">
                                        <Form.Item
                                            name="appDeadEndDate"
                                            rules={[
                                                { validator: (rule, value) => checkEndDate(value) },
                                            ]}
                                        >
                                            <DatePicker placeholder=""
                                                className="searchDatePickerWidth"
                                                value={jobPostModel?.appDeadEndDate ? moment(new Date(jobPostModel.appDeadEndDate), Config.dateFormatEn) : null}
                                                onChange={(value) => modelChange("appDeadEndDate", value)}
                                                format={Config.dateFormatEn}
                                                getPopupContainer={() => document.getElementById('appDeadEndDate')}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='searchFlex'>
                                <div className='label'>Work Location: </div>
                                <div id="workLocIdList">
                                    <Cascader
                                        value={jobPostModel?.workLocIdList || []}
                                        options={areaOptions}
                                        onChange={onChangeAddressA}
                                        changeOnSelect
                                        placeholder=""
                                        getPopupContainer={() => document.getElementById('workLocIdList')}
                                    />
                                </div>
                            </div>
                            <div className='searchFlex'>
                                <div className='label searchViewPotionTitle'>View Option:</div>
                                <Select
                                    value={showMode}
                                    className='searchViewPotion'
                                    options={[
                                        {
                                            label: 'Box',
                                            value: 'Box'
                                        },
                                        {
                                            label: 'List',
                                            value: 'List'
                                        },
                                    ]}
                                    onChange={(value) => changeShowMode(value)}
                                />
                            </div>
                        </div>
                    </Form>
                    <div className='websiteSysSearchRow'>
                        <div className='websiteSysSearchBar'>
                            <input style={{ paddingLeft: '11px' }} placeholder="Search By programme, job title or by job ID"
                                value={jobPostModel?.jobTitle || ''}
                                onKeyDown={(e) => e.key === "Enter" ? searchAllJobList(pageSize, 1, jobSortPostModel) : null}
                                onChange={(e) => modelChange("jobTitle", e.target.value)} />
                            <img src={searchImg} onClick={() => searchAllJobList(pageSize, 1, jobSortPostModel)} />
                        </div>
                        <Popover placement="topRight" trigger="click" open={popoverVisible}
                            onOpenChange={handleOpenChange} content={
                                <PartnerSeeAllJobSort showStatus={showStatus} isReset={isReset} onOpenChange={handleOpenChange2} />
                            }
                            getPopupContainer={() => document.getElementById('sortButton')}
                        >
                            <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                        </Popover>
                        <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
                    </div>
                </div>
                {showMode === 'Box' ?
                    <>
                        {Base.isEmpty(jobList) ? <Empty /> : ''}
                        <div className='seeAllCardBox'>
                            {jobList.map(item =>
                                <div key={item.jobId}
                                    className={'allCardBoxDiv borderColor' + item.jobPostStatus}>
                                    <div className='cardProgrammeRow'>
                                        <div className='cardProgrammeBox' title={item.progTitle}>
                                            <div className='cardProgrammeText'>{item.progTitle}</div>
                                        </div>
                                        <div className={"statusBox " + item.jobPostStatus}>
                                            {statusMap[item.jobPostStatus]}
                                        </div>
                                    </div>
                                    <div className='cardTitleBox'>
                                        <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Job ID</div>
                                        <div className='value'>
                                            {item.jobId}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Job Mode</div>
                                        <div className='value'>
                                            {item.positionTypeVal}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Commence-End</div>
                                        <div className='value'>
                                            {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Application Deadline</div>
                                        <div className='value'>
                                            {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                        </div>
                                    </div>
                                    <div className='cardLine'></div>
                                    <div className='cardButtonBox' >
                                        {item.jobPostStatus === "DRAFT" ?
                                            <Button icon={<img src={deleteIcon} />} className='cardButton' onClick={() => deleteJob(item)}>Delete</Button>
                                            : ""}
                                        {(item.jobPostStatus === "ACTIVE" || item.jobPostStatus === "EXPIRED" || item.jobPostStatus === "WITHDRAWN") ?
                                            <Button icon={<img src={studentImg} />} className='cardButton' onClick={() => jump('/partner/studentApplications/' + item.jobId)}>
                                                Student{item.studentNum > 0 && <div className='studentSpan'>{item.studentNum}</div>}
                                            </Button>
                                            : ""}
                                        <Button icon={<img src={duplicateImg} />} className='cardButton' onClick={() => jumpDuplicate(item.jobId)}>
                                            Duplicate
                                        </Button>
                                        <Dropdown trigger={['hover']}
                                            placement="bottomLeft"
                                            destroyPopupOnHide={true}
                                            // getPopupContainer={() => document.getElementById("jobPostDetail"+item.jobId)}
                                            dropdownRender={() =>
                                                <div>
                                                    {(item.jobPostStatus === "SUBMITTED" || item.jobPostStatus === "DRAFT") ?
                                                        <Button icon={<img src={fillImg} />} onClick={() => jumpDetail(item)}>
                                                            Edit
                                                        </Button>
                                                        :
                                                        <Button icon={<img src={select1} />} onClick={() => jumpDetail(item)}>
                                                            Show Detail
                                                        </Button>
                                                    }
                                                    {item.jobPostStatus === "DRAFT" &&
                                                        <Button icon={<img src={select3} />} disabled={isLoad} onClick={() => saveSubmit(item)}>
                                                            Submit
                                                        </Button>
                                                    }
                                                    {item.jobPostStatus == "ACTIVE" || item.jobPostStatus == "SUBMITTED" ?
                                                        <Button icon={<img src={select5} />} disabled={isLoad} onClick={() => messageConfirmShow('Warning: Withdrawn job posting will terminate all current processing job application and turn status into “Withdrawn”. The offer accepted by student already will not be affected.', item)}>
                                                            Withdrawn
                                                        </Button>
                                                        : ""}
                                                </div>
                                            }
                                        >
                                            <Button id={"jobPostDetail" + item.jobId} icon={<img src={inspectImg} />} className='cardButton'>
                                                Action
                                            </Button>
                                        </Dropdown>
                                    </div>
                                </div>
                            )}
                        </div>
                        {tablesCount > 9 && <div className="pagination" style={{ margin: '20px 0' }}>
                            <Pagination defaultCurrent={1}
                                current={current}
                                pageSize={pageSize}
                                total={tablesCount}
                                itemRender={itemRender}
                                showSizeChanger={false}
                                onChange={onChange}
                            />
                        </div>}
                    </>
                    :
                    <div className="sysTable" id="tableOne" style={{ margin: '0 20px' }}>
                        <Table
                            scroll={{ x: 1200 }}
                            rowKey="jobId"
                            columns={columns} //列名
                            dataSource={jobList} //数据
                            pagination={{  //分页
                                showSizeChanger: true,         //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,       //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,        //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>
                }
            </Spin>
        </div>
    )

}

export default PartnerSeeAllJobPosting;